import React from 'react';
import SignOut from './SignOut';
import '../App.css';

const SafeguardLogo = () => (
  <svg
    width="228"
    height="72"
    viewBox="0 0 1108 607"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4614_1155)">
      <path
        d="M501.729 428.854C483.068 428.854 466.43 425.256 451.816 418.062C437.202 410.867 425.623 400.412 417.079 386.698C408.761 372.758 404.601 356.233 404.601 337.122C404.601 317.112 408.648 299.463 416.742 284.174C424.836 268.886 436.078 257.082 450.467 248.763C465.081 240.22 481.831 235.948 500.717 235.948C520.277 235.948 536.69 240.22 549.955 248.763C563.22 257.082 573.113 269.111 579.633 284.849C586.378 300.587 589.638 319.248 589.413 340.832H423.15V309.468H563.445L543.547 324.307C543.547 313.29 541.974 303.622 538.826 295.303C535.903 286.985 531.182 280.352 524.661 275.406C518.366 270.46 510.385 267.986 500.717 267.986C490.824 267.986 482.168 270.684 474.749 276.08C467.329 281.476 461.596 289.345 457.549 299.688C453.502 310.03 451.479 322.171 451.479 336.11C451.479 348.476 453.615 359.156 457.886 368.149C462.383 377.142 468.454 384 476.098 388.721C483.967 393.218 492.623 395.466 502.066 395.466C515.106 395.466 525.898 391.981 534.442 385.011C543.21 377.817 549.618 368.823 553.665 358.032L591.774 380.964C580.982 397.152 567.829 409.181 552.316 417.05C537.027 424.919 520.165 428.854 501.729 428.854Z"
        fill="#5938B7"
      />
      <path
        d="M699.875 428.854C681.214 428.854 664.576 425.256 649.962 418.062C635.348 410.867 623.769 400.412 615.226 386.698C606.907 372.758 602.747 356.233 602.747 337.122C602.747 317.112 606.794 299.463 614.888 284.174C622.982 268.886 634.224 257.082 648.613 248.763C663.227 240.22 679.977 235.948 698.863 235.948C718.423 235.948 734.836 240.22 748.101 248.763C761.366 257.082 771.259 269.111 777.779 284.849C784.524 300.587 787.784 319.248 787.559 340.832H621.296V309.468H761.591L741.694 324.307C741.694 313.29 740.12 303.622 736.972 295.303C734.049 286.985 729.328 280.352 722.808 275.406C716.512 270.46 708.531 267.986 698.863 267.986C688.97 267.986 680.315 270.684 672.895 276.08C665.476 281.476 659.742 289.345 655.695 299.688C651.648 310.03 649.625 322.171 649.625 336.11C649.625 348.476 651.761 359.156 656.033 368.149C660.529 377.142 666.6 384 674.244 388.721C682.113 393.218 690.769 395.466 700.212 395.466C713.252 395.466 724.044 391.981 732.588 385.011C741.356 377.817 747.764 368.823 751.811 358.032L789.92 380.964C779.128 397.152 765.975 409.181 750.462 417.05C735.173 424.919 718.311 428.854 699.875 428.854Z"
        fill="#5938B7"
      />
      <path
        d="M802.58 183H847.771V380.29C847.771 396.253 848.558 410.867 850.132 424.132H802.58V183Z"
        fill="#5938B7"
      />
      <path
        d="M195 332.528C195 265.737 237.635 236.057 284.386 236.057C327.055 236.057 345.047 263.167 345.047 263.167V183.089H391.26V380.433C391.26 396.632 391.817 411.249 392.948 424.283H345.062V402.134C345.062 402.134 326.726 429 284.402 429C239.281 429 195 403.109 195 332.528ZM296.19 393.541C328.92 393.541 350.08 368.629 350.08 332.528C350.08 295.164 328.904 271.516 296.19 271.516C263.475 271.516 243.081 293.997 243.081 332.528C243.081 371.06 264.334 393.541 296.19 393.541Z"
        fill="#5938B7"
      />
      <path d="M877 380.963H921.517V424.13H877V380.963Z" fill="#5938B7" />
    </g>
    <defs>
      <clipPath id="clip0_4614_1155">
        <rect width="1108" height="607" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export function Navbar() {
  return (
    <nav className="navbar navbar-expand-lg navbar-dark sg-header">
      <div className="container-fluid">
        <a className="navbar-brand" href="#/">
          <SafeguardLogo />
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div
          className="collapse navbar-collapse justify-content-between"
          id="navbarSupportedContent"
        >
          <ul className="navbar-nav me-auto mb-2 mb-lg-0 small">
            <li className="nav-item">
              <span
                className="nav-link active page-header"
                id="homePage"
                aria-current="page"
              >
                Bank Data App
              </span>
            </li>
          </ul>
          <SignOut />
        </div>
      </div>
    </nav>
  );
}
